import React, {useState, useEffect} from "react";
import TopNavigation from "../components/common/TopNavigation";
import useForm from "../components/utilities/useForm"
import { getStateSchema, getValidatorSchema  } from "../components/utilities/utilities"
import {useLocation} from "react-router-dom";
import PaymentSuccess from "../components/steps/PaymentSuccess";
import PaymentFailure from "../components/steps/PaymentFailure";
import EpOverlayLoader from "../components/common/EpOverlayLoader";
import { useTranslation } from 'react-i18next';

function PaymentSummary(props) {    
    const step = {};
    step.id = "payment-summary";
    const search = useLocation().search;
    const orderID = new URLSearchParams(search).get('order');    
    const paymentType=new URLSearchParams(search).get('payment');
    const stateSchema = getStateSchema();
    const stateValidatorSchema = getValidatorSchema();
    const [state, setState] = useState({
      isLoading: false,
      awb: "",
      printLabelUrl: "",
      printReceiptUrl:  "",
      paymentStatus: "",
      firstName: "",
      lastName: "",
      mobileNumber: "",
      emailAddress: ""
    });
    const { t, i18n } = useTranslation();
    const { values, errors, dirty, handleOnChange, setData} = useForm(stateSchema, stateValidatorSchema);

    const handlePasswordOnChange = (event) => {
        handleOnChange(event);
        if(values.confirmValue.length ){            
            setData(
                {"name": "confirmPassword", "value": values.confirmValue === values.accountPassword ? true : false}
            )
        }
    }
    const handlePasswordConfirmChange = (event) => {
        setData(
            {"name": "confirmPassword", "value": event.target.value === values.accountPassword ? true : false}
        )
        setData(
            {"name": "confirmValue", "value": event.target.value}
        )
    }
    const setLocale = (locale) => {
      document.body.setAttribute("lang", locale);
      document.body.setAttribute("dir", locale==="ar"? "rtl" : "ltr");
    } 
    const changeLanguageHandler = () => {
      const language = i18n.language;
      const selectedLocale = language === "en" ? "ar": "en"
      i18n.changeLanguage(selectedLocale);
      setData({"name": "locale", "value": selectedLocale});
      setLocale(selectedLocale);
  }

    useEffect(() => {
      
      let locale = new URLSearchParams(search).get('locale');
     
      const selectedLanguage = locale = "" ? values.locale : locale;
      setLocale(selectedLanguage)
      i18n.changeLanguage(selectedLanguage);
      
      setState(prevState => {
        return { ...prevState, isLoading: true }
      });

      
       

      fetch(
        process.env.REACT_APP_PRODUCTS_API_BASE_URL + "/services/embassy/api/Payments/verfiy?referenceNo=" + orderID,        
      )
        .then((response) => {
          if(!response.ok){            
            setState(prevState => {
              return { ...prevState, isLoading: false, paymentStatus: "FAILED"  }
            });
          }
          return response.json()
        })
        .then((data) => {
          if(data && data.awbNumber){          
            
            setState((prevState) => {
              return {
                ...prevState,
                isLoading: false,
                awb: data.awbNumber,
                printLabelUrl: data.printLabelUrl,
                printReceiptUrl: data.printReceiptUrl,
                paymentStatus: "CAPTURED" 
              };
            });
            fetch(        
              process.env.REACT_APP_PRODUCTS_API_BASE_URL + "/services/embassy/api/Orders/" + orderID
              )
                .then((response) => {
                  if(!response.ok){ 
                  }
                  return response.json()
                })
                .then((orderData) => {
                  setData(
                    {"name": "accountEmail", "value": orderData.emailAddress}
                  )
                  setState((prevState) => {
                    return {
                      ...prevState,
                      firstName: orderData.firstName,
                      lastName: orderData.lastName,
                      mobileNumber: orderData.mobileNumber,
                      emailAddress: orderData.emailAddress
                    };
                  });
                })
                .catch((error)=>{
                  console.log(error);
                })
            
          }else{

          }
        })
        .catch((error) => {
          console.log("API Error", error);
          setState((prevState) => {
            return {
              ...prevState,
              isLoading: false
            }
          });
        });
    }, [orderID]); // eslint-disable-line
    const properties = {values, errors, dirty, handleOnChange, setData, handlePasswordConfirmChange, handlePasswordOnChange, state, changeLanguageHandler, t, step}
    console.log(properties);
    return (
    <div>
      <div className="container">
        <TopNavigation {...properties} />
        {state.paymentStatus === "CAPTURED" && <PaymentSuccess {...properties} /> }
        {state.paymentStatus === "FAILED" && <PaymentFailure {...properties} /> }
      </div>      
      { state.isLoading && <EpOverlayLoader text="Loading.... Please wait..." />}
    </div>
  );
}

export default PaymentSummary;
